<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Báo cáo Trung tâm hỗ trợ GDHN&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button 
          nz-button 
          class="flex items-center justify-center" 
          nzTooltipTitle="Xuất excel" 
          nzTooltipPlacement="bottom" 
          nz-tooltip
          (click)="exportExcel()"
          >
          <i 
            nz-icon 
            nzType="file-excel" 
            nzTheme="twotone"
            ></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button
          nz-button
          class="flex items-center justify-center"
          (click)="exportExcel()"
        >
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button
          nz-button
          class="flex items-center justify-center"
          (click)="exportExcel()"
          >
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Chọn loại hình</nz-form-label>
          <asc-autocomplete [ascModel]="disTypeOfSchoolsControl"
            (ascModelChange)="changeDisTypeOfSchools($event)" placeholder="Chọn loại loại hình..."
            [getListAC]="getDisTypeOfSchoolsACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Tìm kiếm</nz-form-label>
          <input nz-input placeholder="Nhập..." [(ngModel)]="commonFilter.SearchTerm" [ngModelOptions]="{standalone: true}" />
        </nz-form-item>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table
      [nzShowTotal]="rangeTemplate" 
      nzBordered 
      nzShowSizeChanger 
      nzSize="small"
      class="w-full absolute" 
      [nzFrontPagination]="true"
      [nzTotal]="Total" 
      [nzPageSize]="pageSize" 
      [nzPageIndex]="pageIndex" 
      [nzPageSizeOptions]="pageSizeOptions"
      [nzLoading]="loading"
      [nzScroll]="{x: width +'px'}"
      (nzPageIndexChange)="pageIndexEvent($event)" 
      (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr>
          <th nzWidth="50px" 
            rowspan="2"
            >STT
          </th>
          <th class="col-head text-center" rowspan="2" colspan="1" >
              Tổng số
          </th>
          <th class="col-head text-center" colspan="2">
              Cấp tỉnh
          </th>
          <th class="col-head text-center" colspan="2">
              cấp Quận/huyện
          </th>
          <th class="col-head text-center" colspan="2">
              Khác
          </th>
        </tr>
        <tr>
          <th class="col-head text-center" colspan="1">Công lập</th>
          <th class="col-head text-center" colspan="1">Tư thục</th>
          <th class="col-head text-center" colspan="1">Công lập</th>
          <th class="col-head text-center" colspan="1">Tư thục</th>
          <th class="col-head text-center" colspan="1">Công lập</th>
          <th class="col-head text-center" colspan="1">Tư thục</th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>